export default __webpack_public_path__ + "070217ad874162a7c29a03d8ffce0b6e.png";